const TRANSFER_POLICY = Object.freeze({
  allTransfers: 20,
  splitCommissions: 30,
  tipOnly: 40,
  noTransfer: 'NO_TRANSFERS',
});

// noinspection JSUnusedGlobalSymbols
export default TRANSFER_POLICY;
